import React, { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { fetchAllAdminOrgsAsync, selectAllAdminOrgs } from './AdminOrgSlice'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import { Add, Delete, Edit, Group, PlusOne, Refresh } from '@mui/icons-material'
import { selectAuthUser } from '../auth/AuthSlice'

const AdminOrg = () => {
  const dispatch = useAppDispatch()
  const adminOrgs = useAppSelector(selectAllAdminOrgs)
  const navigate = useNavigate()
  const authUser = useAppSelector(selectAuthUser)
  useEffect(() => {
    dispatch(fetchAllAdminOrgsAsync({ mode: 'regular', userAuthorities: authUser?.authorities }))
  }, [])
  return (<div>
    <h1>Admin Org</h1>
    <Button sx={{ marginBottom: 2 }} onClick={() => navigate(`/admin/orgs/edit/0`)}><Add /> Add new Org</Button>
    <Button sx={{ marginBottom: 2 }} onClick={() => dispatch(fetchAllAdminOrgsAsync({ mode: 'regular', userAuthorities: authUser?.authorities }))}><Refresh /> Reload</Button>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Owner</TableCell>
            <TableCell>Paid Tier ID</TableCell>
            <TableCell>Credit Remaining/Refill</TableCell>
            <TableCell>Credit Expiration</TableCell>
            <TableCell> </TableCell>
            <TableCell> </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {adminOrgs.content?.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.ownerEmail}</TableCell>
              <TableCell>{row.paidTier}</TableCell>
              <TableCell>{row.paidTierCount}/{row.refillCount}</TableCell>
              <TableCell>{format(new Date(row.paidTierExpiry * 1000), 'yyyy-MM-dd')}</TableCell>
              <TableCell>
                <Button onClick={() => navigate(`/admin/orgs/manage/${row.id}`)}><Group /></Button>
                <Button onClick={() => navigate(`/admin/orgs/edit/${row.id}`)}><Edit /></Button>
                <Button onClick={() => navigate(`/admin/orgs/delete/${row.id}`)}><Delete /></Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>)
}

export default AdminOrg